import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './style/index.css'
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import axios from './fetch/index'
import commonComponents from './components'

document.title = '在线客服'
message.config({
  maxCount: 1
});
window.Message = message;

Vue.prototype.$bus = new Vue();
Vue.use(Antd);
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$copyText = (text = '', fun) => {
  let input = document.createElement('input')
  input.style.position = 'absolute'
  input.style.top = '-100000px'
  input.value = text // 修改文本框的内容
  document.body.appendChild(input)
  input.select() // 选中文本
  document.execCommand('copy') // 执行浏览器复制命令
  document.body.removeChild(input)
  if (!fun) {
  } else {
    fun()
  }
}
Vue.use(commonComponents)

Vue.config.errorHandler = function (err, vm, info) {
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  // console.log('errorHandler---vm', vm);
  // console.log('errorHandler---info', info);
  console.error('errorHandler---err', err);
  // 不上报的情况
  if(err && err.stack) {
    // 1.Error: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
    if(err.stack.indexOf('localStorage')) {
      return
    }
  }
  const obj = {
    from: 'main.js',
    error: err
  }
  store.dispatch('collectErrorMessage', obj)
}

new Vue({
  el:'#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js